import type { TrinioCheckoutSdk } from './types.ts'

const loadStylesheet = (href: string) =>
    new Promise<void>((resolve, reject) => {
        if (document.querySelector(`link[href="${href}"]`)) {
            resolve()
            return
        }

        const stylesheet = document.createElement('link')
        stylesheet.rel = 'stylesheet'
        stylesheet.href = href
        stylesheet.onload = () => resolve()
        stylesheet.onerror = () => reject(new Error(`Failed to load CSS: ${href}`))
        document.head.appendChild(stylesheet)
    })

const loadScript = (src: string) =>
    new Promise<void>((resolve, reject) => {
        if (document.querySelector(`script[src="${src}"]`)) {
            resolve()
            return
        }

        const script = document.createElement('script')
        script.src = src
        script.async = true
        script.onload = () => resolve()
        script.onerror = () => reject(new Error(`Failed to load script: ${src}`))
        document.body.appendChild(script)
    })

const waitForSdk = (timeoutMs = 15_000, intervalMs = 25) =>
    new Promise<TrinioCheckoutSdk>((resolve, reject) => {
        const startedAt = Date.now()

        const check = () => {
            if (globalThis.window.TrinioCheckout) {
                resolve(globalThis.window.TrinioCheckout)
                return
            }

            if (Date.now() - startedAt >= timeoutMs) {
                reject(new Error('TrinioCheckout SDK timeout'))
                return
            }

            setTimeout(check, intervalMs)
        }

        check()
    })

export const loadTrinioSdk = async (cssHref: string, scriptHref: string) => {
    await Promise.all([loadStylesheet(cssHref), loadScript(scriptHref)])
    return await waitForSdk()
}
